import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { AdvertiserInfoVO } from 'src/app/planner/interfaces/AdvertiserInfo';
import { BudgetingService } from 'src/app/planner/services/budgeting.service';

@Component({
  selector: 'bid-price',
  templateUrl: './bid-price.component.html',
  styleUrls: ['./bid-price.component.scss']
})
export class BidPriceComponent implements OnInit {

  @Input() group: any;
  @Input() formArray: FormArray;
  @Input() advertiserInfo: AdvertiserInfoVO;
  currencySymbol: string = '';

  constructor(private budgetingService: BudgetingService) { }

  ngOnInit() {
    if (this.advertiserInfo.currency) {
      this.currencySymbol = this.budgetingService.getCurrencyAbbrevWithSymbol(this.advertiserInfo.currency);
    }
  }

  get maxBid(): FormControl {
    return this.formArray.controls[this.group].get('maxBid') as FormControl;
  }

  get averageBid(): FormControl {
    return this.formArray.controls[this.group].get('averageBid') as FormControl;
  }
}
